import { render, staticRenderFns } from "./CoachDocRegister.vue?vue&type=template&id=04987b17&scoped=true&"
import script from "./CoachDocRegister.vue?vue&type=script&lang=js&"
export * from "./CoachDocRegister.vue?vue&type=script&lang=js&"
import style0 from "./CoachDocRegister.vue?vue&type=style&index=0&id=04987b17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04987b17",
  null
  
)

export default component.exports